export const adeskPhones = type => {
  if (type === "crewmama") {
    return "312-464-8600"
  } else if (type === "gtt") {
    return "843-884-6222"
  } else if (type === "adesk") {
    return "312-464-8600"
  } else {
    return "843-884-6222"
  }
}
